import http from '../utils/http';
import i18n from '@/main';

const URL_BASE = 'rastreabilidade/fabrica';

export default {
    getFactoriesPaginatedByFilter(body, page, size) {
        return http.post({
            url: `${URL_BASE}/buscar-fabrica-paginado?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazens')
        });
    },
    getTotalizers() {
        return http.get({
            url: `${URL_BASE}/totalizadores`,
            lockScreen: false
        });
    },
    getTransformationPercentages(factoryId) {
        return http.get({
            url: `${URL_BASE}/buscar-percentual-transformacao/${factoryId}`,
            lockScreen: false
        });
    },
    saveTransformationPercentages(factoryId, data) {
        return http.post({
            url: `${URL_BASE}/salvar-percentual-transformacao/${factoryId}`,
            data
        });
    }
};
